import { ComponentProps } from 'preact';
import { Icon } from './Icon';
import { useUser } from '../hooks/UNSAFE_useUser';

type Props = Omit<ComponentProps<typeof Icon>, 'viewBox'>;

// Returns a component that renders one of the given icon components based on reading direction
export const withDirectionIcon = (LtrIcon: typeof Icon, RtlIcon: typeof Icon) => {
  return (props: Props) => {
    const { direction } = useUser();
    return direction === 'ltr' ? <LtrIcon {...props} /> : <RtlIcon {...props} />;
  };
};
